import { gql, useQuery } from '@apollo/client';
import { Box, Heading, Stack } from '@chakra-ui/react';
import * as React from 'react';

import { Redraft } from '@/components/Redraft';
import { Prose } from '@/imports/ui/chakra/components/Prose';
import { MilleFeuille, MilleFeuilleMain } from '@/layouts/MilleFeuille';
import { FooterRender } from '@/modules/website-builder';
import { TENANT_FRAGMENT } from '@/queries';

import { TermsAndConditions_TenantAndTerms } from './graphql-types/TermsAndConditions_TenantAndTerms';

const TENANT_AND_TERMS = gql`
  query TermsAndConditions_TenantAndTerms {
    tenant {
      result {
        _id
        termsAndConditions
        ...TenantFragment
      }
    }
  }
  ${TENANT_FRAGMENT}
`;

export const TermsAndConditions: React.FC = () => {
  const { data } =
    useQuery<TermsAndConditions_TenantAndTerms>(TENANT_AND_TERMS);

  return (
    <MilleFeuille>
      <MilleFeuilleMain>
        <Box maxW="container.md" mx="auto" p="10">
          <Stack spacing="10">
            <Heading size="xl">Terms and Conditions</Heading>
            {data?.tenant.result?.termsAndConditions && (
              <Prose>
                <Redraft
                  rawDraftContentState={data?.tenant.result.termsAndConditions}
                />
              </Prose>
            )}
          </Stack>
        </Box>
      </MilleFeuilleMain>
      {data?.tenant.result && <FooterRender tenant={data.tenant.result} />}
    </MilleFeuille>
  );
};
